<template>
    <div class="main-business-content">
        <h3 class="main-business-title">{{details.title}}</h3>
        <div v-html="details.content"></div>

    </div>
</template>

<script>
export default {
    name:'mainBusiness',
    data(){
        return {
            details:''
        }
    },
    mounted(){
        this.baseUrl=window.baseUrl;
        this.config=window.config;
        this.businessId=this.$route.params.business_id;
        this.getBusiness();
    },
    methods:{
        getBusiness:function(){
            var that=this;
            that.$http.post(that.baseUrl+that.config.MassInfo+"?business_id="+that.businessId).then(function(ev){
                console.log(ev);
                if(ev.data.code==100){
                    that.details=ev.data.data;
                }
            });
        }
    },
    
    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mainBusiness.vue